import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
	getActions,
	getAllActions,
	createAction,
	updateAction,
	deleteAction,
} from "../services/action.service";

// Re-export types for convenience
export type {
	ActionRequest,
	ActionUpdateRequest,
} from "../services/action.service";

export const useGetActions = (
	search?: string,
	page?: number,
	pageSize?: number,
) => {
	return useQuery({
		queryKey: ["actions", search, page, pageSize],
		queryFn: () => getActions(search, page, pageSize),
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
};

export const useGetAllActions = () => {
	return useQuery({
		queryKey: ["actions", "all"],
		queryFn: () => getAllActions(),
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
};

export const useCreateAction = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: createAction,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["actions"] });
		},
	});
};

export const useUpdateAction = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: updateAction,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["actions"] });
		},
	});
};

export const useDeleteAction = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: deleteAction,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["actions"] });
		},
	});
};
